module.exports = __webpack_public_path__ + "img/bg_4.89786e53.jpg";